// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__ZiYVW","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2thhI","obliqueLine":"membershipbadge_obliqueLine__kczDQ"};